import { useMemo } from 'react';

import { RingTableColumnKeys } from 'business/production-and-performance/pages/ring-table/types';
import { SteeringTableParamsProps } from 'business/steering/hooks/use-get-steering-data-query';
import { SteeringTableFilterData } from 'business/steering/pages/table-page';
import { SteeringTableContainer } from 'business/steering/pages/table-page/components/steering-table-container';
import { FilterDataSetter } from 'technical/filter-data';

const defaultCurrentPage = 1;
const defaultPageSize = Infinity;

const defaultOrderBy = {
  sortOrder: 'descend',
  sortField: RingTableColumnKeys.RingNumber,
} as const;

export const MobileSteeringTableWithPagination = ({
  setFilterData,
}: {
  setFilterData: FilterDataSetter<SteeringTableFilterData>;
}) => {
  const tableParams = useMemo(() => {
    return {
      current: defaultCurrentPage,
      pageSize: defaultPageSize,
      ...defaultOrderBy,
      position: ['none'],
    } satisfies SteeringTableParamsProps;
  }, []);

  return (
    <SteeringTableContainer
      tableParams={tableParams}
      setFilterData={setFilterData}
    />
  );
};
